export default class WordScript{
    /**
     * Склоняет слово в зависимости от числа
     * @param {number} number - Число
     * @param {string[]} words - Массив форм слова [для 1, для 2-4, для 5+]
     * @returns {string} Правильная форма слова
     */
    static declineWord(number, words) {
        const cases = [2, 0, 1, 1, 1, 2];
        return words[
        number % 100 > 4 && number % 100 < 20
            ? 2
            : cases[Math.min(number % 10, 5)]
        ];
    };
}
